// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonLink_btn__3leIN","disabled":"ButtonLink_disabled__2A8pD","sizeMedium":"ButtonLink_sizeMedium__2q0YU","sizeLarge":"ButtonLink_sizeLarge__5mnBY"};